import React from "react";
import { useParams } from "react-router-dom";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import { slugify } from "../utils";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import SEO from "../common/SEO";
import { ProjectSecondData } from "../component/project/ProjectSecondData";
import ErrorPage from "./404";
const allProjectData = ProjectSecondData;

const PortfolioProjectDetails = () => {
    const params = useParams();
    const projectSlug = params.slug;

    const getProjectData = allProjectData.find(
        (data) => slugify(data.id) === projectSlug
    );

    if (!getProjectData) {
        return <ErrorPage />;
    }

    const projectDescription = getProjectData
        ? (getProjectData.excerpt || (getProjectData.body && getProjectData.body[0]) || "").replace(/<[^>]+>/g, "").slice(0, 155)
        : "";
    const projectCanonical = `https://itcodeinfotech.com/Portfolio-project-details/${projectSlug}`;

    return (
        <>
            <SEO
                metaTitle={getProjectData ? `${getProjectData.header || getProjectData.title} | ITCODE InfoTech` : "Project Details | ITCODE InfoTech"}
                metaDescription={projectDescription}
                metaRobots="noindex, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
                canonicalTag={projectCanonical}
                ogTitle={getProjectData ? getProjectData.header || getProjectData.title : "Project Details"}
                ogType="article"
                ogUrl={projectCanonical}
                ogDescription={projectDescription}
            />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <div className="breadcrum-area">
                    <div className="section">
                        {/* <div className="container">
              <div className="about-expert">
                <div className="d-block ">
                  <Slider {...slideSettings} className="slick-dot-nav">
                    {getProjectData.image1.map((img, index) => (
                      <div className="thumbnail p-lg-5 p-3 shadow-none bg-white border d-flex justify-content-center">
                        <img
                          src={img}
                          alt={`Project Image ${index}`}
                          key={index}
                          style={{maxHeight: "500px" , borderRadius : "5px"}}
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
              <div class="section-padding pb-0">
                <h2 class="title">Project Details</h2>
                <p className="mb-0">
                  {getProjectData.body.map((text, index) => (
                    <span key={index} style={{ marginBottom: "1rem" }}>
                      {text}
                    </span>
                  ))}
                </p>
              </div>
            </div> */}

                        <div
                            className="section case-study-featured-area"
                        >
                            <div className="container">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-6 px-xl-5 px-2">
                                        <div className="case-study-featured-thumb text-start">

                                            <img
                                                src={getProjectData.img}
                                                alt={getProjectData.header || getProjectData.title}
                                                style={{
                                                    borderRadius: "15px",
                                                    boxShadow: "0px 0px 6px -2px #00000063",
                                                }}
                                            />

                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-6">
                                        <div className="case-study-featured mb-0">
                                            <div className="section-heading heading-left mb-0">
                                                {/* <span className="subtitle">Core Feature</span> */}
                                                <h1 className="portfolio_title" style={{marginBottom: "10px"}}>{getProjectData.header}</h1>
                                                <p><a href={getProjectData.link} target="_blank" rel="nofollow noopener noreferrer">{getProjectData.link}</a></p>
                                                <p className="mb-0">
                                                    {getProjectData.body.map((text, index) => (
                                                        <span key={index} style={{ marginBottom: "1rem" , textAlign: "justify"}}>
                                                            {text}
                                                        </span>
                                                    ))}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ul className="shape-group-17 list-unstyled">
                            <li className="shape shape-1">
                                <img
                                    src={process.env.PUBLIC_URL + "/images/others/circle-2.png"}
                                    alt="circle"
                                />
                            </li>
                            <li className="shape shape-2">
                                <img
                                    src={process.env.PUBLIC_URL + "/images/others/bubble-2.png"}
                                    alt="Line"
                                />
                            </li>
                            <li className="shape shape-3">
                                <img
                                    src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"}
                                    alt="Line"
                                />
                            </li>
                        </ul>
                    </div>
                </div>

                <CtaLayoutOne />
                <FooterOne parentClass="" />
            </main>
        </>
    );
};

export default PortfolioProjectDetails;
